import React from 'react';
// @ts-ignore
import styles from './SelectionList.module.scss';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';

export interface SelectionListItemScheme {
	id: string;
	name: string;
}

interface Props {
	item: SelectionListItemScheme;
	onClick: (item: SelectionListItemScheme) => void;
	buttonLabel: string;
}

const SelectionListItem: React.FC<Props> = ({ item, buttonLabel, onClick }) => (
	<div className={styles.item}>
		<div className={styles.title}>{item.name}</div>
		<div>
			<Button
				theme={Theme.GREEN}
				title={buttonLabel}
				onClick={() => onClick(item)}
			/>
		</div>
	</div>
);

export default SelectionListItem;
